module.exports = __webpack_public_path__ + "img/interior_designer.8d32e049.png";